import { elementConstants } from "../../constants/cms/form/element/element.constants";

export const defaultArticleElement = {
  data: {
    hidden: false,
    conditions: [],
    style: { width: "100%" },
    padding: 10,
    margin: 0,
    displayType: "TEXT",
  },
  eventId: 0,
  formId: null,
  pageId: null,
  parentId: null,
  formElementId: -1,
  languageCode: "",
  id: -1,
  page: 1,
  props: {},
  sortOrder: 0,
  type: elementConstants.ARTICLE,
};

export const defaultContainerElement = {
  data: {
    hidden: false,
    conditions: [],
    style: { width: 100, height: 200 },
    padding: 10,
    margin: 0,
    backgroundColor: "unset",
    background: "unset",
    backgroundUrl: "",
    backgroundAttachment: "initial",
    type: "DEFAULT",
    validation: {
      message: "",
    },
    extra: null,
  },
  eventId: 0,
  formId: null,
  pageId: null,
  parentId: null,
  formElementId: -1,
  languageCode: "",
  id: -1,
  page: 1,
  props: {
    elements: [],
  },
  sortOrder: 0,
  type: elementConstants.CONTAINER,
};

export const defaultFieldElement = {
  data: {
    hidden: false,
    labelAlign: "left",
    style: { width: 70, padding: 0 },
    padding: 10,
    showSubLabel: false,
    showSubInput: false,
    validation: { type: "none", message: "" },
    conditions: [],
    titleWidth: 20,
    inputWidth: 80,
    maxCharacters: 100,
    displayType: "TEXT",
    sortType: "DEFAULT",
    selectOptions: [],
  },
  eventId: 0,
  formId: 0,
  parentId: null,
  formElementId: -1,
  languageCode: "",
  id: -1,
  page: 1,
  props: {
    name: "FirstName",
    type: "Person",
    length: 0,
    labels: [],
    subLabels: [],
    subInputs: [],
    text: "",
  },
  sortOrder: 0,
  type: elementConstants.FIELD,
};
export const defaultInvoiceElement = {
  data: {
    hidden: false,
    labelAlign: "left",
    style: { width: "100%", padding: 0 },
    padding: 10,
    validation: { type: "none", message: "" },
    conditions: [],
    titleWidth: 20,
    inputWidth: 80,
    maxCharacters: 100,
    displayType: "TEXT",
    selectOptions: [],
    name: "FirstName",
    type: "Invoice",
    defaultCountry: "swe",
    invoiceCountries: [],
    length: 0,
    labels: [],
  },
  eventId: 0,
  formId: 0,
  parentId: null,
  formElementId: -1,
  languageCode: "",
  id: -1,
  page: -1,
  props: {
    name: "FirstName",
    type: "Invoice",
    length: 0,
    labels: [],
    text: "",
  },
  sortOrder: 0,
  type: elementConstants.INVOICE_FIELD,
};

export const defaultProfileImageUploaderElement = {
  data: {
    hidden: false,
    shape: "CIRCLE",
    size: { width: 1024, height: 1024 },
    viewport: { width: 200, height: 200 },
    defaultImage: "",
  },
  eventId: 0,
  formId: 0,
  parentId: null,
  formElementId: -1,
  languageCode: "",
  id: -1,
  page: -1,
  props: {},
  sortOrder: 0,
  type: elementConstants.PROFILEIMAGE_UPLOAD,
};

export const defaultContentElement = {
  data: {
    hidden: false,

    conditions: [],
    padding: 10,
    margin: 0,
    backgroundColor: "unset",
  },
  eventId: 0,
  formId: null,
  pageId: null,
  parentId: null,
  formElementId: -1,
  languageCode: "",
  id: -1,
  page: 1,
  props: {
    value: "",
    type: null,
  },
  sortOrder: 0,
  type: elementConstants.CONTENT,
};

export const defaultUserPageElement = {
  data: {
    hidden: false,
    conditions: [],
    padding: 10,
    margin: 0,
    backgroundColor: "unset",
    style: {
      height: "400px",
    },
  },
  eventId: 0,
  formId: null,
  pageId: null,
  parentId: null,
  formElementId: -1,
  languageCode: "",
  id: -1,
  page: 1,
  props: {
    confId: -1,
  },
  sortOrder: 0,
  type: elementConstants.USER_PAGE,
};

export const defaultQuestionElement = {
  data: {
    hidden: false,
    labelAlign: "left",
    style: { width: "100%", padding: 0 },
    padding: 10,
    validation: { type: "none", message: "Enter errormessage.." },
    conditions: [],
    titleWidth: 20,
    inputWidth: 80,
    textRows: 1,
    minCharacters: 0,
    maxCharacters: 100,
    showSubLabel: false,
    showSubInput: false,
    displayType: "CHECKBOX",
    sortType: "DEFAULT",
    selectOptions: [],
    inline: false,
    optionSpacing: "0px",
    checkboxLabelPlacement: "end",
    hideCheckboxLabels: false,
    displayCheckboxRowAsHeader: false,
    /*    displayType: 'LIST' */
  },
  eventId: 0,
  formId: 0,
  parentId: null,
  formElementId: -1,
  languageCode: "",
  id: -1,
  page: 1,
  props: {
    type: "Text",
    requiredMin: 0,
    requiredMax: 1,
    labels: [],
    subLabels: [],
    subInputs: [],
    options: null,
  },
  sortOrder: 0,
  type: elementConstants.QUESTION,
};
export const defaultEventElement = {
  data: {
    hidden: false,
    labelAlign: "center",
    style: { width: "100%", padding: 0 },
    padding: 10,
    parentId: null,
    validation: { type: "none", message: "Enter errormessage.." },
    allowOverbooking: false,
    maxLabel: "",
    locationLabel: "",
    groupId: -1,
    hidePrice: false,
    descriptionMargin: 0,
    display: {
      name: true,
      startDate: true,
      endDate: true,
      startTime: true,
      endTime: true,
      description: true,
      max: true,
      price: true,
      city: true,
      venue: true,
      priceExVat: true,
      priceIncVat: true,
      vatSum: true,
      vatPercent: true,
    },
    preChecked: false,
    readOnly: false,
    doNotExistIfHidden: false,
    conditions: [],
    maxCharacters: 100,
  },
  eventId: 0,
  formId: 0,
  formElementId: -1,
  languageCode: "",
  id: -1,
  page: 1,
  props: {
    name: "",
    startDateTime: Date.now(),
    endDateTime: Date.now() + 1,
    description: "",
    max: 0,
    amount: 0,
    city: "",
    venue: "",
    vatPercent: 0,
  },
  sortOrder: 0,
  type: elementConstants.EVENT,
};

export const defaultPaymentElement = {
  eventId: 0,
  formId: 0,
  parentId: null,
  formElementId: -1,
  languageCode: "",
  id: -1,
  page: 1,
  sortOrder: 0,
  data: {
    selectedPaymentMethod: "",
    paymentMethods: [],
    hidden: false,
    required: false,
    labelAlign: "left",
    style: { width: "100%", padding: 0 },
    padding: 10,
    validation: { type: "none", message: "" },
    conditions: [],
    titleWidth: 20,
    inputWidth: 80,
    maxCharacters: 100,
    labels: [],
  },
  props: {},
  type: elementConstants.PAYMENT_OPTIONS,
};

export const defaultPreConfirmationElement = {
  eventId: 0,
  formId: 0,
  parentId: null,
  formElementId: -1,
  languageCode: "",
  id: -1,
  page: 1,
  sortOrder: 0,
  data: {
    hidden: false,
    style: { width: "100%", padding: 0 },
    padding: 10,
    validation: { type: "none", message: "" },
    conditions: [],
  },
  props: {},
  type: elementConstants.PRE_CONFIRMATION,
};

export const defaultDiscountElement = {
  eventId: 0,
  formId: 0,
  parentId: null,
  formElementId: -1,
  languageCode: "",
  id: -1,
  page: 1,
  sortOrder: 0,
  data: {
    hidden: false,
    style: { width: "100%", padding: 0 },
    padding: 10,
    validation: { type: "none", message: "" },
    conditions: [],
  },
  props: {},
  type: elementConstants.DISCOUNT,
};

export const defaultGroupRegistrationElement = {
  eventId: 0,
  formId: 0,
  parentId: null,
  formElementId: -1,
  languageCode: "",
  id: -1,
  page: 1,
  sortOrder: 0,
  data: {
    hidden: false,
    style: { width: "100%", padding: 0 },
    padding: 10,
    validation: { type: "none", message: "" },
    conditions: [],
    returnPage: 1,
  },
  props: {},
  type: elementConstants.GROUP_REGISTRATION,
};


export const defaultFileUploaderElement = {
  eventId: 0,
  formId: 0,
  parentId: null,
  formElementId: -1,
  languageCode: "",
  id: -1,
  page: 1,
  sortOrder: 0,
  data: {
    hidden: false,
    style: { width: "100%", padding: 0 },
    padding: 10,
    validation: { type: "none", message: "" },
    conditions: [],
    allowedFiletypes: []
  },
  props: {},
  type: elementConstants.FILE_UPLOADER,
};
